export default {
  // 发货指令列表查询
  GET_DATA_API: '/warehouse/shippingInstruction/listShippingInstructionByPage',
  //发货指令保存/提交物流/生成业务入库单
  SAVE_DATA_API: '/warehouse/shippingInstruction/saveShippingInstruction',
  //查看发货指令详情
  DETAIL_DATA_API: '/warehouse/shippingInstruction/getShippingInstruction/',
  //撤回发货指令
  BACK_OUT_API: '/warehouse/shippingInstruction/updateShippingInstructionBackout',
  //删除发货指令
  DEL_DATA_API: '/warehouse/shippingInstruction/deleteShippingInstruction',
  //新增附件
  ADD_ATTACH_API: '/warehouse/attachment/saveStorageAttachment',
  //删除附件
  DEL_ATTACH_API: '/warehouse/attachment/deleteStorageAttachment',
  //附件列表
  GET_ATTACH_API: '/warehouse/attachment/listStorageAttachmentByPage',
  //获取新的发货指令编码
  GET_NEWNO_API: '/warehouse/shippingInstruction/getNewInstructionNo',
  // 业务入库列表查询
  LIST_BUSINESS_INBOUND: '/warehouse/businessInbound/listBusinessInboundByPage',
  // 物流入库列表
  LIST_DISTRIBUTION_INBOUND: '/warehouse/businessInbound/listBusinessInboundByPage',
  // 物流入库单弹框
  LIST_DISTRIBUTION_INBOUND_DIALOG:
    '/warehouse/distributionInbound/listDistributionInboundForBusiByPage',
  // 根据合同号查询行项目剩余业务入库总数
  GET_REST_INBOUND_QUANTITY: '/warehouse/businessInbound/getRestInboundQuantityByContractNo',
  // 查询采购合同详情
  GET_ORDER: '/sales/order/getOrder',
  // 新增业务入库
  SAVE_BUSINESS_INBOUND: '/warehouse/businessInbound/saveBusinessInbound',
  // 提交业务入库前校验
  SUBMIT_CHECK_BUSINESS_INBOUND: '/warehouse/businessInbound/checkBeforeBatchCommit',
  // 提交业务入库
  SUBMIT_BUSINESS_INBOUND: '/warehouse/businessInbound/submitBusinessInbound',
  // 查询业务入库
  GET_BUSINESS_INBOUND: '/warehouse/businessInbound/getBusinessInbound',
  // 更新、编辑业务入库
  UPDATE_BUSINESS_INBOUND: '/warehouse/businessInbound/updateBusinessInbound',
  // 计算业务入库商品行项目价格
  COUNT_PRICE: '/warehouse/businessInbound/countPrice',
  // 删除业务入库
  DELETE_INBOUND: '/warehouse/businessInbound/deleteBusinessInbound',
  // 获取已经业务入库的
  GET_TOTAL_QUANTITY: '/warehouse/businessInbound/getTotalInboundQuantityByInstructionNo',
  //物流入库查祥请
  GETDISTRIBUTIONINBOUND_DATA_API: '/warehouse/distributionInbound/getDistributionInbounds',
  //业务结算价不含税单价
  CALCULATE_LOCAL_AMOUNT: 'sales/orderTrade/calculateLocalAmount',

  // ============ sunxueping 添加批量导入 ============
  IMPORT_BUSINESS_RECEIPT: '/warehouse/businessInbound/importExcel',
  // ================================================
  // ============ sunxueping 添加导出 ============
  EXPORT_BUSINESS_RECEIPT: '/warehouse/businessInbound/exportBusinessInboundExcel',
  // ================================================
  // 批量确认
  DO_BATCH_CONFIRM: '/warehouse/businessInbound/doBatchConfirm',
  // ============ sunxueping 批量过帐 ============
  PURCHASE_RETURN_VOUCHER: '/warehouse/businessInbound/batchSyncVoucher',
  // 批量标记过账
  PURCHASE_RETURN_SIGN_VOUCHER: '/warehouse/businessInbound/batchSignSyncVoucher',
  // ================================================
  // ============ sunxueping 批量提交 ============
  BATCH_COMMIT: '/warehouse/businessInbound/batchCommitByIds',
  // ================================================
  // 确认按钮
  DO_CONFIRM: '/warehouse/businessInbound/doConfirm',
  // 撤回
  DO_WITHDRAW: '/warehouse/businessInbound/doWithdraw',
  // 新业务导入
  IMPORT_BUSINESS_RECEIPT_NEW: '/warehouse/businessInbound/importSupplyExcel',
  /**打印查询 */
  GET_FILE: '/maindata/dict/getFileTemplate',
  /**打印或下载 */
  EXPORT_PRINT: '/sales/busiInbound/exportPrint',

  // 根据发货指令生成业务入库单
  CREATE_INBOUND_BY_SHIP: '/warehouse/shippingInstruction/createInboudByInstruction',
  // 根据物流入库单生成业务入库单
  CREATE_INBOUND_BY_DISTRI: '/warehouse/shippingInstruction/createInboudByDistribution',
};
